import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import AccommodationLinks from '@/scopes/common/components/AccommodationLinks'
import SectionTitle from '@/scopes/destinations/components/SectionTitle'

export default function LinkedAccommodations() {
  const intl = useIntl()
  const data = useCMSPageField('LinkedAccommodations')

  if (!data?.accommodations?.length) {
    return null
  }

  return (
    <section>
      <SectionTitle>{intl.formatMessage({ id: 'linked_accommodations_title' }, { destinationName: data?.destinationName || '' })}</SectionTitle>
      <AccommodationLinks accommodations={data.accommodations} />
    </section>
  )
}
